import { Injectable } from '@angular/core';
import { AgentData, AgentView, AuthResponse, Server, Token } from 'src/app/models/server-v2';
import { RpaHttpService } from '../http/rpa-http.service';
import { LocalStorageService } from '../storage/local-storage.service';
import { Observable } from 'rxjs';



@Injectable({
  providedIn: 'root'
})
export class RpaIdClientService {


  constructor(private rpa: RpaHttpService,
    private stor: LocalStorageService) { }

  getServers() {
    return this.rpa.get<Server[]>('/public/Auth/GetServers')
  }

  getToken(code: string, server: string) {
    const filter = {
      code: code,
      server: server,
      deviceUID: this.stor.widevineId
    }
    return this.rpa.post<Token>('/public/Auth/GetToken', filter)
  }

  requestAccess(agentCode: string, server: string): Observable<AuthResponse> {
    const query = {
      code: agentCode,
      server: server,
      deviceUID: this.stor.widevineId
    }
    return this.rpa.post<AuthResponse>('/public/Auth/requestAccess', query)
  }

  getProfiles(query: any):Observable<AgentView[]> {
    return this.rpa.post<AgentView[]>('/public/Auth/getprofiles', query)
  }

}

